import React, { useState } from 'react';
const BoxScore = () => {
  const [activeTeam, setActiveTeam] = useState('both');
  // Mock box score data
  const boxScoreData = {
    quarters: ['Q1', 'Q2', 'Q3', 'Q4', 'Total'],
    home: {
      name: 'New York Knicks',
      scores: [28, 31, 24, 29, 112]
    },
    away: {
      name: 'Los Angeles Lakers',
      scores: [24, 28, 30, 26, 108]
    },
    leadChanges: 12,
    timesTied: 8
  };
  // Extended stats for each quarter
  const quarterDetails = [{
    quarter: 'Q1',
    home: {
      fgm: 11,
      fga: 22,
      fgp: 50.0,
      tpm: 3,
      tpa: 8,
      tpp: 37.5,
      ftm: 3,
      fta: 4,
      ftp: 75.0,
      rebounds: 12,
      assists: 7,
      steals: 2,
      blocks: 1,
      turnovers: 3,
      fouls: 5,
      points: 28
    },
    away: {
      fgm: 9,
      fga: 21,
      fgp: 42.9,
      tpm: 2,
      tpa: 7,
      tpp: 28.6,
      ftm: 4,
      fta: 4,
      ftp: 100.0,
      rebounds: 10,
      assists: 5,
      steals: 1,
      blocks: 0,
      turnovers: 4,
      fouls: 4,
      points: 24
    }
  }, {
    quarter: 'Q2',
    home: {
      fgm: 12,
      fga: 23,
      fgp: 52.2,
      tpm: 4,
      tpa: 9,
      tpp: 44.4,
      ftm: 3,
      fta: 5,
      ftp: 60.0,
      rebounds: 11,
      assists: 8,
      steals: 3,
      blocks: 2,
      turnovers: 2,
      fouls: 3,
      points: 31
    },
    away: {
      fgm: 11,
      fga: 24,
      fgp: 45.8,
      tpm: 3,
      tpa: 8,
      tpp: 37.5,
      ftm: 3,
      fta: 3,
      ftp: 100.0,
      rebounds: 9,
      assists: 6,
      steals: 1,
      blocks: 1,
      turnovers: 4,
      fouls: 5,
      points: 28
    }
  }, {
    quarter: 'Q3',
    home: {
      fgm: 9,
      fga: 20,
      fgp: 45.0,
      tpm: 2,
      tpa: 6,
      tpp: 33.3,
      ftm: 4,
      fta: 6,
      ftp: 66.7,
      rebounds: 10,
      assists: 4,
      steals: 1,
      blocks: 1,
      turnovers: 4,
      fouls: 4,
      points: 24
    },
    away: {
      fgm: 12,
      fga: 25,
      fgp: 48.0,
      tpm: 4,
      tpa: 10,
      tpp: 40.0,
      ftm: 2,
      fta: 3,
      ftp: 66.7,
      rebounds: 12,
      assists: 7,
      steals: 2,
      blocks: 1,
      turnovers: 3,
      fouls: 6,
      points: 30
    }
  }, {
    quarter: 'Q4',
    home: {
      fgm: 10,
      fga: 21,
      fgp: 47.6,
      tpm: 3,
      tpa: 9,
      tpp: 33.3,
      ftm: 6,
      fta: 7,
      ftp: 85.7,
      rebounds: 11,
      assists: 5,
      steals: 2,
      blocks: 1,
      turnovers: 4,
      fouls: 3,
      points: 29
    },
    away: {
      fgm: 10,
      fga: 22,
      fgp: 45.5,
      tpm: 2,
      tpa: 7,
      tpp: 28.6,
      ftm: 4,
      fta: 5,
      ftp: 80.0,
      rebounds: 8,
      assists: 4,
      steals: 3,
      blocks: 1,
      turnovers: 4,
      fouls: 7,
      points: 26
    }
  }];
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-15" data-mp="2wltdhyokvwge">
      <h2 className="text-xl font-bold mb-6" data-id="element-16" data-mp="2wml1oofuirwn">Box Score</h2>
      {/* Team Toggle */}
      <div className="flex mb-6 bg-gray-100 rounded-lg p-1 w-fit" data-id="element-17" data-mp="2sj52bkce6dg9">
        <button onClick={() => setActiveTeam('both')} className={`px-4 py-2 text-sm font-medium rounded-md ${activeTeam === 'both' ? 'bg-white shadow' : 'text-gray-600 hover:text-gray-800'}`} data-id="element-18" data-mp="36jpomqhimrei">
          Both Teams
        </button>
        <button onClick={() => setActiveTeam('home')} className={`px-4 py-2 text-sm font-medium rounded-md ${activeTeam === 'home' ? 'bg-white shadow' : 'text-gray-600 hover:text-gray-800'}`} data-id="element-19" data-mp="3g8zdzykz5vyx">
          {boxScoreData.home.name}
        </button>
        <button onClick={() => setActiveTeam('away')} className={`px-4 py-2 text-sm font-medium rounded-md ${activeTeam === 'away' ? 'bg-white shadow' : 'text-gray-600 hover:text-gray-800'}`} data-id="element-20" data-mp="3kcp1ekpwy7id">
          {boxScoreData.away.name}
        </button>
      </div>
      {/* Basic Box Score */}
      <div className="overflow-x-auto" data-id="element-21" data-mp="1scji2e737vdq">
        <table className="min-w-full bg-white border border-gray-200" data-id="element-22" data-mp="1wdlhav1087fp">
          <thead data-id="element-23" data-mp="1wfplle2tf8gi">
            <tr className="bg-gray-50" data-id="element-24" data-mp="znc9emdx5per">
              <th className="py-3 px-4 text-left font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-25" data-mp="zodyhurrscfh">
                Team
              </th>
              {boxScoreData.quarters.map((quarter, index) => <th key={index} className="py-3 px-4 text-center font-medium text-gray-500 uppercase tracking-wider border-b" data-id="element-26" data-mp="18mh6rpdqvcpc" data-mpi={index}>
                  {quarter}
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-27" data-mp="2p1hbnt33pn9b">
            {(activeTeam === 'both' || activeTeam === 'away') && <tr className="hover:bg-blue-50" data-id="element-28" data-mp="2z6qudccf59pz">
                <td className="py-3 px-4 border-b font-medium text-blue-600" data-id="element-29" data-mp="2z5fqzdmvy3ze">
                  {boxScoreData.away.name}
                </td>
                {boxScoreData.away.scores.map((score, index) => <td key={index} className={`py-3 px-4 text-center border-b ${index < 4 && boxScoreData.away.scores[index] > boxScoreData.home.scores[index] ? 'font-bold' : ''}`} data-id="element-30" data-mp="2pebc0dx7mj4k" data-mpi={index}>
                    {score}
                  </td>)}
              </tr>}
            {(activeTeam === 'both' || activeTeam === 'home') && <tr className="hover:bg-red-50" data-id="element-31" data-mp="26jczrkw70q91">
                <td className="py-3 px-4 border-b font-medium text-red-600" data-id="element-32" data-mp="22gzuexlcyucs">
                  {boxScoreData.home.name}
                </td>
                {boxScoreData.home.scores.map((score, index) => <td key={index} className={`py-3 px-4 text-center border-b ${index < 4 && boxScoreData.home.scores[index] > boxScoreData.away.scores[index] ? 'font-bold' : ''}`} data-id="element-33" data-mp="pwim4zqf9qn" data-mpi={index}>
                    {score}
                  </td>)}
              </tr>}
          </tbody>
        </table>
      </div>
      <div className="mt-4 text-sm text-gray-600 flex space-x-6" data-id="element-34" data-mp="1p996gtxwy41p">
        <div data-id="element-35" data-mp="2cy1t1zsnazjn">Lead Changes: {boxScoreData.leadChanges}</div>
        <div data-id="element-36" data-mp="2cylc5ju17tz9">Times Tied: {boxScoreData.timesTied}</div>
      </div>
      {/* Detailed Quarter Stats */}
      <div className="mt-8" data-id="element-37" data-mp="2hw3m9djscf8u">
        <h3 className="text-lg font-semibold mb-4" data-id="element-38" data-mp="23x3y0706q2d7">Quarter Details</h3>
        <div className="space-y-6" data-id="element-39" data-mp="23wu9knusg39m">
          {quarterDetails.map((qData, index) => <div key={index} className="border rounded-lg overflow-hidden" data-id="element-40" data-mp="28uncn80soh5o" data-mpi={index}>
              <div className="bg-gray-50 px-4 py-2 font-medium border-b" data-id="element-41" data-mp="sgx5fsedpcrt">
                {qData.quarter === 'Q1' ? 'First Quarter' : qData.quarter === 'Q2' ? 'Second Quarter' : qData.quarter === 'Q3' ? 'Third Quarter' : 'Fourth Quarter'}
              </div>
              <div className="overflow-x-auto" data-id="element-42" data-mp="yyqjogcimwfs">
                <table className="min-w-full" data-id="element-43" data-mp="yxfh2jut3uq9">
                  <thead data-id="element-44" data-mp="tym4qur9a9ro">
                    <tr className="bg-gray-50" data-id="element-45" data-mp="u0fckddlv019">
                      <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-46" data-mp="69jcksyzwyix">
                        Team
                      </th>
                      <th className="py-2 px-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-47" data-mp="1c9p3iv62wxq">
                        FG
                      </th>
                      <th className="py-2 px-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-48" data-mp="b7umf3paj915">
                        3PT
                      </th>
                      <th className="py-2 px-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-49" data-mp="3epuusjyrdgfa">
                        FT
                      </th>
                      <th className="py-2 px-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-50" data-mp="2y54qjjwpr6tq">
                        REB
                      </th>
                      <th className="py-2 px-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-51" data-mp="332wjmh93gyzi">
                        AST
                      </th>
                      <th className="py-2 px-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-52" data-mp="3c44fyts1vpqy">
                        STL
                      </th>
                      <th className="py-2 px-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-53" data-mp="3luficbw35qvq">
                        BLK
                      </th>
                      <th className="py-2 px-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-54" data-mp="3vsvdqr25bmb1">
                        TO
                      </th>
                      <th className="py-2 px-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-55" data-mp="3mzvae0d34i9">
                        PF
                      </th>
                      <th className="py-2 px-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-56" data-mp="1k4qih6d0rwze">
                        PTS
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-57" data-mp="1a9gewe6z3hji">
                    {(activeTeam === 'both' || activeTeam === 'away') && <tr className="hover:bg-blue-50" data-id="element-58" data-mp="27x6w94pq52sw">
                        <td className="py-2 px-3 text-sm font-medium text-blue-600" data-id="element-59" data-mp="22x2ihmg7am6d">
                          Lakers
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-60" data-mp="1y2y80t7q7w0j">
                          {qData.away.fgm}-{qData.away.fga} (
                          {qData.away.fgp.toFixed(1)}%)
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-61" data-mp="2lv5ckfnlv9b1">
                          {qData.away.tpm}-{qData.away.tpa} (
                          {qData.away.tpp.toFixed(1)}%)
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-62" data-mp="32szbzixhm794">
                          {qData.away.ftm}-{qData.away.fta} (
                          {qData.away.ftp.toFixed(1)}%)
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-63" data-mp="3cpki67l8toej">
                          {qData.away.rebounds}
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-64" data-mp="3qnsdkb2mshnl">
                          {qData.away.assists}
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-65" data-mp="49inzymyt3l8">
                          {qData.away.steals}
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-66" data-mp="3vj7n4qtlvre7">
                          {qData.away.blocks}
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-67" data-mp="9aoia0w9wywv">
                          {qData.away.turnovers}
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-68" data-mp="rw4faaywkvqw">
                          {qData.away.fouls}
                        </td>
                        <td className="py-2 px-3 text-center text-sm font-bold" data-id="element-69" data-mp="iy26h98xgyt2">
                          {qData.away.points}
                        </td>
                      </tr>}
                    {(activeTeam === 'both' || activeTeam === 'home') && <tr className="hover:bg-red-50" data-id="element-70" data-mp="dxwefryqxaag">
                        <td className="py-2 px-3 text-sm font-medium text-red-600" data-id="element-71" data-mp="dzh87fd8kp79">
                          Knicks
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-72" data-mp="47uy5mcmww63">
                          {qData.home.fgm}-{qData.home.fga} (
                          {qData.home.fgp.toFixed(1)}%)
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-73" data-mp="3rc11o8o2sg5i">
                          {qData.home.tpm}-{qData.home.tpa} (
                          {qData.home.tpp.toFixed(1)}%)
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-74" data-mp="1s4kmt22ybi0o">
                          {qData.home.ftm}-{qData.home.fta} (
                          {qData.home.ftp.toFixed(1)}%)
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-75" data-mp="1j7a816qxdar0">
                          {qData.home.rebounds}
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-76" data-mp="2btl7ge2sp5m8">
                          {qData.home.assists}
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-77" data-mp="26t72x60ekdsy">
                          {qData.home.steals}
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-78" data-mp="vgebxxffrtdy">
                          {qData.home.blocks}
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-79" data-mp="qfguxo65x5e1">
                          {qData.home.turnovers}
                        </td>
                        <td className="py-2 px-3 text-center text-sm" data-id="element-80" data-mp="lbeq8lpkzech">
                          {qData.home.fouls}
                        </td>
                        <td className="py-2 px-3 text-center text-sm font-bold" data-id="element-81" data-mp="q9gavb2nnlq2">
                          {qData.home.points}
                        </td>
                      </tr>}
                  </tbody>
                </table>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default BoxScore;